export const checkPaymentType = () => {
    let kbankType = localStorage.getItem("kbank")
    let scbType = localStorage.getItem("scb")
    let _2c2pType = localStorage.getItem("2c2p")

    if (kbankType === "true") {
        return "kbank"
    }

    if (scbType === "true") {
        return "scb"
    }

    if (_2c2pType === "true") {
        return "2c2p"
    }

    return "mpay"

}
